<template>
  <v-container fill-height fluid grid-list-xl class="pa-3">
    <v-layout column wrap class="px-2">
      <div class="headline mb-2">Navigation Items</div>
      <v-layout row wrap>
        <div
          style="background-color: #5cb860; width: 370px; height: fit-content;"
          class="pa-2 mb-4 mx-3"
        >
          <!-- <v-layout
                        row
                        class="title mb-3 mt-0 px-2 pt-1 font-weight-light"
                        style="color: #fff; margin-left: -1px; margin-right: -1px;"
                        >Favorites<v-spacer></v-spacer>
                        <v-btn
                            small
                            class="mt-0 mb-0"
                            style="color: #4caf50; background-color: #FFF"
                            @click="openAddFavoriteDialog"
                            >Add</v-btn
                        >
                    </v-layout> -->
          <v-layout
            row
            class="mb-3 mt-0 pl-2"
            style="color: #fff; margin-left: -1px; margin-right: -1px;"
          >
            <v-icon class="mt-1" style="color: #fff;">mdi-star-box</v-icon>
            <div class="title ml-2 font-weight-light" style="padding-top: 9px;">
              Favorites
            </div>
            <v-spacer></v-spacer>
            <v-btn
              small
              class="mt-0 mb-0 mr-2"
              style="color: #4caf50; background-color: #FFF; margin-top: 4px !important;"
              @click="openAddFavoriteDialog"
              >Add</v-btn
            >
          </v-layout>

          <draggable
            v-model="favoritesItems"
            group="favorites"
            @start="drag = true"
            @end="drag = false"
            @change="favoritesItemOrderChanged"
          >
            <v-card
              class="pa-3 mb-2"
              style="width: 350px; cursor: pointer;"
              v-for="item in favoritesItems"
              @click="openRemoveFavoriteDialog(item)"
            >
              <v-layout row>
                <v-icon class="ml-2">{{ item.icon }}</v-icon>
                <div class="title ml-2 mt-2">
                  {{ item.text }}
                </div>
                <v-spacer></v-spacer>
                <v-icon class="mr-2">mdi-close</v-icon>
              </v-layout>
            </v-card>
          </draggable>
        </div>

        <div v-for="group in getGroupedItems()">
          <div
            style="background-color: #5cb860; width: fit-content;"
            class="pa-2 mb-4 mx-3"
          >
            <v-layout
              row
              v-if="group.parent != 'main'"
              class="mb-3 mt-0 pl-2"
              style="color: #fff; margin-left: -1px; margin-right: -1px;"
            >
              <v-icon class="mt-1" style="color: #fff;">{{
                getParentIcon(group.parent)
              }}</v-icon>
              <div
                class="title ml-2 font-weight-light"
                style="padding-top: 9px;"
              >
                {{ group.parent }}
              </div>
              <v-spacer></v-spacer>
              <v-btn
                small
                class="mt-0 mb-0 mr-2"
                style="color: #4caf50; background-color: #FFF; margin-top: 4px !important;"
                @click="openGroupSettingDialog(group)"
                >{{ isAllHidden(group) ? "Unhide" : "Hide" }}</v-btn
              >
            </v-layout>
            <v-card
              class="pa-3 mb-2"
              style="width: 350px;"
              v-for="item in group.items"
            >
              <v-layout row>
                <v-icon class="ml-2">{{ item.icon }}</v-icon>
                <div class="title ml-2 mt-2">
                  {{ item.text }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  style="cursor: pointer;"
                  class="mr-2"
                  @click="itemFavoriteSetting(item)"
                  v-bind:class="{
                    'is-favorite-item': isFavorite(item),
                  }"
                  >mdi-star-box</v-icon
                >
                <v-icon
                  style="cursor: pointer;"
                  class="mr-2"
                  @click="openNavigationSettingDialog(item)"
                  >{{ item.visible ? "mdi-eye" : "mdi-eye-off" }}</v-icon
                >
              </v-layout>
            </v-card>
          </div>
        </div>
      </v-layout>
    </v-layout>

    <v-dialog persistent v-model="navigationSettingsDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Navigation Item: {{ clickedItem.text }}</v-card-title
        >
        <v-switch
          color="success"
          class="mt-0"
          v-model="clickedItem.visible"
          label="Visible"
        ></v-switch>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="navigationSettingsDialog = false"
            >Close</v-btn
          >
          <v-btn :loading="processing" color="success" @click="save()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="favoritesItemsDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Add Favorite</v-card-title>
        <!-- <v-select
                    label="Item"
                    v-model="selectedItem"
                    :items="links.map((l) => l.displayName)"
                    :rules="[rules.required]"
                    ref="selectedItem"
                ></v-select> -->
        <v-autocomplete
          class=""
          label="Item"
          placeholder="Start typing..."
          hide-no-data
          ref="selectedItem"
          v-model="selectedItem"
          :items="favoritesItemsList.map((l) => l.displayName)"
          :rules="[rules.required]"
          :search-input.sync="loadFavoriteItems"
        ></v-autocomplete>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="favoritesItemsDialog = false"
            >Close</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveFavorite()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="removeFavoriteDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Favorite Item: {{ favoriteToRemove.text }}</v-card-title
        >
        <div class="mb-2">
          <span class="font-weight-medium">{{ favoriteToRemove.text }}</span>
          will be removed from favorites
        </div>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="removeFavoriteDialog = false"
            >Close</v-btn
          >
          <v-btn :loading="processing" color="success" @click="removeFavorite()"
            >Remove</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="groupVisibiltySettingDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Are You Sure?</v-card-title>
        <div class="mb-3">
          <span class="font-weight-medium">{{ selectedGroup.parent }}</span>
          {{
            isAllHidden(selectedGroup)
              ? "items will be visible"
              : "items will be hidden"
          }}
        </div>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            @click="groupVisibiltySettingDialog = false"
            >Close</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveGroup()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
import { onlyUnique, groupBy } from "../../utils/helpers.js";
import linkList from "../../components/core/Links.js";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data: () => ({
    navigationItems: [],
    favoritesItems: [],
    links: [],
    favoritesItemsList: [],
    clickedItem: {},
    navigationSettingsDialog: false,
    favoritesItemsDialog: false,
    removeFavoriteDialog: false,
    favoriteToRemove: {},
    processing: false,
    selectedItem: "",
    loadFavoriteItems: null,
    selectedGroup: {},
    groupVisibiltySettingDialog: false,

    rules: {
      required: (value) => !!value || "Required",
    },
  }),
  watch: {
    loadFavoriteItems(value) {
      if (!value) return;
      if (!this.links.length) return;

      this.favoritesItemsList = this.links.filter((b) =>
        b.displayName.toUpperCase().includes(value.toUpperCase())
      );
    },
  },
  async created() {
    this.setup();
  },
  computed: {},
  methods: {
    async setup() {
      const items = [];

      linkList
        .filter((l) => !l.sublinks)
        .forEach((item) => {
          item.parent = "main";
          items.push(item);
        });

      linkList
        .filter((l) => l.sublinks)
        .map((item) => {
          return item.sublinks.map((sublink) => {
            sublink.parent = item.text;

            return sublink;
          });
        })
        .flat()
        .forEach((item) => {
          items.push(item);
        });

      const navigationSettings = await this.loadNavigationSettings();

      this.navigationItems = items.map((item) => {
        const setting = navigationSettings.find(
          (n) =>
            n.navigationItem == item.text &&
            n.navigationGroup == item.parent &&
            !n.isFavorite
        );

        item.visible = !setting || !setting.hidden;

        return item;
      });

      this.favoritesItems = [];

      navigationSettings
        .filter((n) => n.isFavorite)
        .forEach((ns) => {
          const item = items.find(
            (i) => i.parent == ns.navigationGroup && i.text == ns.navigationItem
          );

          if (!item) return;

          this.favoritesItems.push({
            id: ns.id,
            text: ns.navigationItem,
            isFavorite: true,
            parent: ns.navigationGroup,
            icon: item.icon,
            visible: true,
            sortOrder: ns.sortOrder,
          });
        });

      this.sortFavoritesItems();

      this.links = items
        .filter(this.isNotInFavorites)
        .map((link) => {
          link.displayName = link.parent + "/" + link.text;

          return link;
        })
        .sort((a, b) => {
          if (a.displayName < b.displayName) {
            return -1;
          }
          if (a.displayName > b.displayName) {
            return 1;
          }
          return 0;
        });
    },
    isNotInFavorites(item) {
      return !this.favoritesItems.some(
        (i) => i.text == item.text && i.parent == item.parent
      );
    },
    isAllHidden(group) {
      if (!group || !group.items) return;

      return group.items.every((i) => !i.visible);
    },
    sortFavoritesItems() {
      this.favoritesItems = this.favoritesItems.sort((a, b) => {
        if (a.sortOrder < b.sortOrder) {
          return -1;
        }
        if (a.sortOrder > b.sortOrder) {
          return 1;
        }
        return 0;
      });
    },
    itemFavoriteSetting(item) {
      if (this.isFavorite(item)) {
        const favoritesItem = this.favoritesItems.find(
          (f) => f.text == item.text && f.parent == item.parent
        );

        return this.openRemoveFavoriteDialog(favoritesItem);
      }

      this.openAddFavoriteDialog(item);
    },
    openAddFavoriteDialog(item = null) {
      if (item) {
        this.selectedItem = item.parent + "/" + item.text;
      } else {
        this.selectedItem = "";
      }

      this.favoritesItemsDialog = true;
      this.favoritesItemsList = this.links;
      this.$refs.selectedItem.resetValidation();
    },
    openRemoveFavoriteDialog(item) {
      this.favoriteToRemove = item;
      this.removeFavoriteDialog = true;
    },
    async loadNavigationSettings() {
      const user = this.$store.state.authentication.user;
      if (!user) return;

      const response = await this.$http.get(
        "api/adminPortal/getNavigationSettings?userName=" + user
      );

      return response;
    },
    openNavigationSettingDialog(item) {
      if (item.text == "Navigation Settings") return;

      this.clickedItem = item;
      this.navigationSettingsDialog = true;
    },
    async favoritesItemOrderChanged(event) {
      await this.$http.post(
        "api/adminPortal/saveNavigationSettings",
        this.favoritesItems.map((item, index) => ({
          isFavorite: true,
          navigationItem: item.text,
          sortOrder: index + 1,
          navigationGroup: item.parent,
          hidden: false,
          username: this.$store.state.authentication.user,
        }))
      );
    },
    getGroupedItems() {
      const navigationItems = this.navigationItems.filter((i) => i.parent);

      if (!navigationItems.length) return;

      return Object.keys(groupBy(navigationItems, "parent")).map((parent) => {
        return {
          parent,
          items: groupBy(navigationItems, "parent")[parent],
        };
      });
    },
    getParentIcon(parent) {
      return linkList.find((l) => l.text == parent).icon;
    },
    isFavorite(item) {
      return this.favoritesItems.some(
        (f) => f.text == item.text && f.parent == item.parent
      );
    },
    openGroupSettingDialog(group) {
      this.selectedGroup = group;
      this.groupVisibiltySettingDialog = true;
    },
    async saveGroup() {
      try {
        this.processing = true;

        const hidden = !this.isAllHidden(this.selectedGroup);

        await this.$http.post(
          "api/adminPortal/saveNavigationSettings",
          this.selectedGroup.items.map((item) => ({
            navigationItem: item.text,
            navigationGroup: item.parent,
            hidden: hidden,
            username: this.$store.state.authentication.user,
          }))
        );

        this.groupVisibiltySettingDialog = false;
        this.processing = false;

        this.setup();
      } catch (e) {
        this.processing = false;
      }
    },
    async save() {
      try {
        this.processing = true;

        await this.$http.post("api/adminPortal/saveNavigationSettings", [
          {
            navigationItem: this.clickedItem.text,
            navigationGroup: this.clickedItem.parent,
            hidden: !this.clickedItem.visible,
            username: this.$store.state.authentication.user,
          },
        ]);

        this.navigationSettingsDialog = false;
        this.processing = false;

        this.raiseEvent();

        this.setup();
      } catch (e) {
        this.processing = false;
      }
    },
    raiseEvent() {
      // const evt = document.createEvent("Event");
      // evt.initEvent("myEvent",true,true);
    },
    async saveFavorite() {
      try {
        this.processing = true;

        const parent = this.selectedItem.split("/")[0];
        const text = this.selectedItem.split("/")[1];

        const item = this.links.find(
          (i) => i.parent == parent && i.text == text
        );

        await this.$http.post("api/adminPortal/saveNavigationSettings", [
          {
            navigationItem: item.text,
            navigationGroup: item.parent,
            hidden: false,
            username: this.$store.state.authentication.user,
            isFavorite: true,
            sortOrder: this.favoritesItems.length + 1,
          },
        ]);

        this.favoritesItemsDialog = false;
        this.processing = false;

        this.setup();
      } catch (e) {
        this.processing = false;
      }
    },
    async removeFavorite() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/adminPortal/removeNavigationSettings?id=" +
            this.favoriteToRemove.id
        );

        this.removeFavoriteDialog = false;
        this.processing = false;

        this.setup();
      } catch (e) {
        this.processing = false;
      }
    },
  },
};
</script>
<style>
.is-favorite-item {
  color: red !important;
}
</style>
